import { render, staticRenderFns } from "./card-actions.vue?vue&type=template&id=5318197b&scoped=true"
import script from "./card-actions.vue?vue&type=script&lang=js"
export * from "./card-actions.vue?vue&type=script&lang=js"
import style0 from "./card-actions.vue?vue&type=style&index=0&id=5318197b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318197b",
  null
  
)

export default component.exports